import React from 'react';
import { observer } from 'mobx-react';

import {
  DisplayList,
  EntryCard,
  EntryTitle,
} from 'containers/EntitiesFormSubmission/components/RepeatingGroupField/RepeatingGroupField.styles';

import { asRows, asText, isObject, PartnerRow, PartnerValue } from './partnerValue';
import { EmptyValue } from 'components/SharedFormComponents/CustomFieldDisplayValue/styles';

import { PartnerText, RowLabel, Rows } from './styles';

const Card = ({ title, rows }: { title?: string; rows: PartnerRow[] }): React.ReactElement => (
  <EntryCard>
    {title ? <EntryTitle>{title}</EntryTitle> : null}
    <Rows>
      {rows.map((row, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={index}>
          <RowLabel>{row.label}</RowLabel>
          <PartnerText>{row.text}</PartnerText>
        </React.Fragment>
      ))}
    </Rows>
  </EntryCard>
);

const PartnerAnswer = ({ label, value }: { label: string; value: PartnerValue }): React.ReactElement => {
  const text = asText(value);
  if (text !== null) {
    return <PartnerText id="partner-value">{text}</PartnerText>;
  }

  if (Array.isArray(value)) {
    return (
      <DisplayList id="partner-entries">
        {value.map((entry, index) => (
          <Card
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            title={`${label} ${index + 1}`}
            rows={isObject(entry) ? asRows(entry) : [{ label, text: asText(entry) ?? '' }]}
          />
        ))}
      </DisplayList>
    );
  }

  const rows = isObject(value) ? asRows(value) : [];

  return rows.length > 0 ? (
    <DisplayList id="partner-entries">
      <Card rows={rows} />
    </DisplayList>
  ) : (
    <EmptyValue id="empty-value">-</EmptyValue>
  );
};

export default observer(PartnerAnswer);
